import {ResponsiveService} from '../../../../../../core/services/responsive.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit, Renderer2,
  ViewChild,
  ViewChildren,
  Output, EventEmitter
} from '@angular/core';
import {DocumentTypeService} from '../../../../../../core/services/document-type.service';
import {UserService} from '../../../../../../core/services/user.service';
import {DocumentMohaService} from '../../../../../../core/services/document-moha.service';
import {MatDialog} from '@angular/material/dialog';
import {NotificationService} from '../../../../../../core/services/notification.service';
import {CommonService} from '../../../../../../core/services/common.service';
import {Message} from '../../../../../../core/class/message';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {BranchService} from 'src/app/core/services/branch.service';
import {MatSort, Sort} from '@angular/material/sort';
import {FormControl, NgForm} from '@angular/forms';
import {MatSelect} from '@angular/material';
import {BehaviorSubject, merge, Observable, of, ReplaySubject, Subject, Subscription} from 'rxjs';
import {CdkDetailRowDirective} from 'src/app/shared/directive/cdk-detail-row.directive';
import {takeUntil, take, tap, map, catchError, filter, switchMap} from 'rxjs/operators';
import {WarningComponent} from '../../../../../../shared/components/warning/warning.component';
import {DataSource} from '@angular/cdk/collections';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {BaseComponent} from '../../../../../../shared/components/base/base.component';
import {EnumContractStatus, EnumContractUserRole} from 'src/app/core/constants/contract';
import {CancelSignFlowComponent} from '../cancel-sign-flow/cancel-sign-flow.component';
import {WarningSmsContractService} from 'src/app/core/services/warning-sms-contract.service';
import {ErrorCode} from '../../../../../../core/constants/error-code';
import {DeviceDetectorService} from 'ngx-device-detector';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {ListSignContractNotifyComponent} from './sign-contract-notify-moha/sign-contract-notify-moha.component';
import {ForwardContractDialogComponent} from '../forward-contract-dialog/forward-contract-dialog.component';
import {SignatureProcessDialogComponent} from '../signature-process-dialog/signature-process-dialog.component';
import data from '../../../../../../shared/components/pdf-viewer/data';
import * as JSZip from 'jszip';
import {ListMultipleSignDialogComponent} from './multiple-sign-dialog-moha/multiple-sign-dialog-moha.component';
import {ProcessingService} from 'src/app/core/services/processing.service';
import {createTrue} from 'typescript';
import {NotifyWarningComponent} from 'src/app/shared/components/notify-warning/notify-warning.component';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ResendContractDialogComponent} from '../resend-contract-dialog/resend-contract-dialog.component';
import {WarningCancelSignConfirmationComponent} from '../warning-cancel-sign-confirmation/warning-cancel-sign-confirmation.component';
import {ReSignatureProcessDialogComponent} from '../re-signature-process-dialog/re-signature-process-dialog.component';
import {NotifyWarningCustomComponent} from '../../../../../../shared/components/notify-warning-custom/notify-warning-custom.component';
import {ListMultiDeleteDialogComponent} from './multi-delete-dialog-moha/multi-delete-dialog-moha.component';
import {MultiDownloadService} from '../../../../../../core/services/multi-download.service';
import {EnumDownloadMenuName} from '../../../../../../core/constants/common';
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import {ListSignatureProcessPopupComponent} from "./signature-process-popup-moha/signature-process-popup-moha.component";
import {ListPopupCancelFlowComponent} from "./popup-cancel-flow-moha/popup-cancel-flow-moha.component";
import {EnumColumnTable, EnumContractUserStatus} from 'src/app/core/constants/contract';
import {ListManageContractSharePartnerComponent} from './manage-contract-share-partner-moha/manage-contract-share-partner-moha.component';
import { ListConfirmTerminationComponent } from './confirm-termination-moha/confirm-termination-moha.component';
import { ContractService } from 'src/app/core/services/contract.service';
import { WarningDataAuthenticationComponent} from 'src/app/shared/components/warning-data-authentication/warning-data-authentication.component';
import { SignAuthenticationPopupComponent } from '../../document/add-document-moha/sign-aunthentication-popup/sign-aunthentication-popup.component';
import { RequestConfirmIdentityComponent } from 'src/app/shared/components/request-confirm-identity/request-confirm-identity.component';
import { EnterIdentityVneidComponent } from 'src/app/shared/components/enter-identity-vneid/enter-identity-vneid.component';


@Component({
  selector: 'app-search-document-contract-moha',
  templateUrl: './search-document-contract-moha.component.html',
  styleUrls: ['./search-document-contract-moha.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
      state('*', style({height: '*', visibility: 'visible'})),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ListSearchDocumentContractComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Check status of document for process update
   */
  @BlockUI() blockUI: NgBlockUI;
  checkUpdateDocument = false;
  SignatureProcess:any;
  private EventWarningContractSubscription: Subscription;
  public warningContractQuantity = false;
  private isAutoSign = false;
  private dialogRef: any;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  isDisableNamePhoneEmail = true;
  public cecaEnable: boolean;
  percent: any;
  isNotAttestedUser: boolean = false;

  permissions: any;
  userType: any;

  constructor(
    private documentTypeService: DocumentTypeService,
    private usService: UserService,
    private documentMohaService: DocumentMohaService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private branchService: BranchService,
    private changeDetectorRefs: ChangeDetectorRef,
    private warningSmsContractService: WarningSmsContractService,
    private responsiveService: ResponsiveService,
    private processingService: ProcessingService,
    private downloadService: MultiDownloadService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private contractService: ContractService,
    public deviceService: DeviceDetectorService,
  ) {
    super(commonService, message);
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.getColumnByUser().subscribe();
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.percent = 0 ;
    this.permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    this.userType = localStorage.getItem('userType');
  }

  @Output() changeView: EventEmitter<boolean> = new EventEmitter<boolean>();


  onAddDocument(element?: any): void {
    this.changeView.emit(element);
    // this.router.navigate(['/home-enterprise/new-document-moha/']);
  }

  documentTypeEnterprise = {
    documentTypeId: 0,
    name: '',
    parentId: null,
    serviceTypeId: null
  };

  documentEnterprise = {
    documentId: 0,
    name: '',
    parentId: null,
    id: null
  };

  dataCheckVneid = {
    typeVerify: '',
    certificateNoCCCD: '',
    timeWaitShare: 60
  }

  // displayedColumns: string[] = [
  //   'STT',
  //   'name',
  //   'allName',
  //   'serviceTypeName',
  //   'status',
  //   'createdTime',
  //   'action',
  // ];

  displayedColumns: string[] = [];

  columnDefinitions = [
    {def: 'check', default: true , showXS: true, showSM: true, showMD: true, name: '', check: true},
    {def: 'STT', default: true , showXS: true, showSM: true, showMD: true, name: '', check: true},

    //add more
    {def: 'uuidContractMoha', default: true , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.uuid_Contract', check: true},
    // {def: 'nameContract', default: true , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.name_Contract', check: true},
    {def: 'name', default: true , showXS: true, showSM: true, showMD: true, name: '', check: true},
    {def: 'allName', default: true , showXS: false, showSM: false, showMD: true, name: 'headertable.contract_parties', check: true},
    {def: 'allEmail', default: true , showXS: false, showSM: false, showMD: true, name: 'headertable.contract_parties_email', check: true},
    {def: 'serviceTypeName', default: true , showXS: false, showSM: false, showMD: true, name: 'form.service_type', check: true},
    {def: 'status', default: true , showXS: false, showSM: false, showMD: false, name: 'enterprise_contract.table_headers.document_status', check: true},

    //add more
    {def: 'mohaConfirmStatus', default: true , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.status_send_up', check: true},
    {def: 'mohaStatus', default: true , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.status_sign', check: true},

    {def: 'createdTime', default: true , showXS: false, showSM: false, showMD: true, name: 'enterprise_contract.table_headers.created_date', check: true},
    {def: 'statusRecipient', default: false , showXS: false, showSM: false, showMD: true, name: 'headertable.recipient_status', check: false},
    {def: 'statusOriginator', default: false , showXS: false, showSM: false, showMD: true, name: 'headertable.opposite_status', check: false},
    {def: 'expiredDate', default: false , showXS: false, showSM: false, showMD: true, name: 'enterprise-certificate_management.lbl_end_date', check: false},
    {def: 'submittedByATime', default: false , showXS: false, showSM: false, showMD: true, name: 'searchDocumentMine.lbl_submitByATime', check: false},
    {def: 'expireStatus', default: false , showXS: false, showSM: false, showMD: true, name: 'searchDocumentMine.lbl_validity', check: false},
    {def: 'customerGroups', default: false , showXS: false, showSM: false, showMD: true, name: 'form.group_customer', check: false},
    {def: 'typeId', default: false , showXS: false, showSM: false, showMD: true, name: 'search_form.method_creation', check: false},
    {def: 'negotiate', default: false , showXS: false, showSM: false, showMD: true, name: 'negotiate_contract.label', check: false},
    {def: 'formType', default: false , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.form_type', check: false},
    {def: 'contractMohaErrorDescription', default: false , showXS: false, showSM: false, showMD: true, name: 'header.reason', check: false},
    {def: 'action', default: true , showXS: true, showSM: true, showMD: true, name: '', check: true},

  ];
  tableWidth = 1250;

  // displayedChildColumns: string[] = [
  //   'check',
  //   'STT',
  //   'name',
  //   'allName',
  //   'allEmail',
  //   'serviceTypeName',
  //   'status',
  //   'createdTime',
  //   'customerGroups',
  //   'typeId',
  //   'action',
  // ];
  enumColumnTable = EnumColumnTable;
  enumContractUserStatus = EnumContractUserStatus;

  enumContractStatus = EnumContractStatus;
  documents = new Document();
  enumContractUserRole = EnumContractUserRole;
  checkFocus = true;
  isSelectOpen = true;
  checkAll: boolean;
  totalProcesses = 0;
  dataIsProcess: any;

  dataSelected: Map<string, Document> = new Map<string, Document>();
  checkSignatureProcess:any;
  checkCancelFlow:any;

  public countCheck: number = 0;

  public countDraft: number = 0;

  public selected: number = 0;
  dataSource: DocumentDataSource;
  childDataSourceList: DocumentTypeDataSourceKeyPair = {};
  showSelect: boolean = false;
  paginate: Paginate;
  childPaginateList: PaginateKeyPair = {};

  oldData = this.documents;
  childOldDataList: DocumentKeyPair = {};

  isFirstLoad = true;
  isTableLoading = false;
  // Plan A: list API chi duoc goi sau khi API cau hinh cot (user-config) da tra ve
  // signal bat = true sau khi getColumnByUser() da ap config + getDisplayedColumns()
  private columnConfigLoaded$ = new BehaviorSubject<boolean>(false);
  childIsFirstLoadList: BooleanKeyPair = {};

  childIsExexpanding: Array<string>;

  subscriptions: Subscription = new Subscription();
  isDraftAll: any = 0;
  isDeleteDraftAll: boolean = false;
  selectedDraftAll: any[] = [];
  subTitleDraftAll: any;
  subTitleDraftAllTotal: any;

  isVContract: boolean = true;
  isShowMenuDelete : boolean = false;
  isShowMenuSign : boolean = false;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('myForm', {static: false}) ngForm: NgForm;
  @ViewChild('statusSelect', {static: false}) statusSelect: MatSelect;
  @ViewChild('serviceTypeSelect', {static: false}) serviceTypeSelect: MatSelect;
  @ViewChild('typeIdSelect', {static: false}) typeIdSelect: MatSelect;
  @ViewChild('negotiateSelect', {static: false}) negotiateSelect: MatSelect;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('signRoleSelect', {static: false}) signRoleSelect: MatSelect;
  @ViewChild('select', {static: false}) select: MatSelect;
  @ViewChild('menuSign', {static: false}) menuSign: MatMenuTrigger;
  @ViewChild('menuFeature', {static: false}) menuFeature: MatMenu;
  @ViewChild('formTypeSelect', {static: false}) formTypeSelect: MatSelect;
  @ViewChild('formTypeSelectSend', {static: false}) formTypeSelectSend: MatSelect;

  closeMenu() {
    this.isShowMenuDelete = false;
    this.isShowMenuSign = false;
  }
  openMenuDelete() {
    this.isShowMenuDelete = !this.isShowMenuDelete;
  }
  openMenuSign() {
    this.isShowMenuSign = !this.isShowMenuSign;
  }

  childSortList: SortKeyPair = {};

  sortDirection = 'ASC';
  childSortDirection: StringKeyPair = {};

  sortColumn = 'name';
  sortChildColumn: StringKeyPair = {};

  timeOut: any;

  error = '';
  subscription: Subscription;
  expanded = [];
  openedRow: CdkDetailRowDirective;
  parentDocuments: Document[];
  isProcess = false;
  checkMan:any;
  inputReasonValue:any;
  newInitialInfoValue:any;
  signDoneQuantity = 0;
  signErrorQuantity = 0;
  isProgress = false;
  isStop = false;
  isDocumentManager: boolean;
  enterpriseId: string;
  isCheckedAllColumn: boolean = false;
  // List all parent branches
  // parentBranches: { id: string, name: '' }[];
  // Selected model value for autocomplete
  selectedBranch: { id: string, name: '' };


  // List all parent branches
  documentTypes: comboBox[] = [];
  serviceTypes: comboBox[] = [];
  isServiceTypesLoading = false;
  selectedOptions: any[] = [];
  documentTypesFilterCtrl: FormControl = new FormControl();
  serviceTypesFilterCtrl: FormControl = new FormControl();

  public filteredDocumentTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private onDestroySubject = new Subject<void>();

  isBasicSearchForm = true;

  createdDateErr = '';
  finishedDateErr = '';

  signContractId: any;

  @Input() singleChildRowDetail: boolean;


  isExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.isServiceTypesLoading = true;
    this.commonService.getEnterpriseServiceType(enterpriseId).subscribe(rs => {
      this.isServiceTypesLoading = false;
      if (rs && rs.data) {
        this.serviceTypes = rs.data;
        const filteredData = rs.data.filter(item => item.isEmploymentContract === true);
        this.filteredServiceTypes.next(filteredData);
        this.documents.serviceType = this.documents.serviceType ? Number(this.documents.serviceType) : null;
      }
    }, () => this.isServiceTypesLoading = false);
  }
  ngOnInit() {
    this.getDisplayedColumns();
    if (this.commonService.checkEnterpriseType()) {
      this.isVContract = false;
    }



    // if (this.isVContract) {
    //   this.columnDefinitions.splice(-4, 0, {def: 'bctConfirmStatus', default: true , showXS: false, showSM: false, showMD: true,  name: 'headertable.send_bct', check: true});
    //   this.displayedChildColumns.splice(-4, 0, 'bctConfirmStatus');
    // }
    this.documentMohaService.getSignContractFlowProcessingId().subscribe(rs => {
      if (rs && rs.data !== null) {
        const keys = Object.keys(rs.data)[0];
        this.signContractId = keys;
        for (const value of Object.values(rs.data)) {
          if (value === 'SIGN_FLOW_LOT') {
            this.onClickConfirmButton();
            this.isProcess = true;
            this.checkMan = 1 ;
            localStorage.setItem('checkMan', '1');
            break;
          } else if (value === 'DELETE_CONTRACT_LOT') {
            this.onClickDeleteConfirmButton();
            this.isProcess = true;
            this.checkMan = 5 ;
            localStorage.setItem('checkMan', '5');
            break;
          } else if (value === 'CANCEL_FLOW_LOT') {
            this.onClickConfirmButtonCancel();
            this.isProcess = true;
            this.checkMan = 2 ;
            localStorage.setItem('checkMan', '2');
            break;
          } else if (value === 'CONFIRM_SIGN_LOT') {
            this.onClickConfirmButtonSignProcess();
            this.isProcess = true;
            this.checkMan = 3 ;
            localStorage.setItem('checkMan', '3');
            break;
          }
        }
      } else {
        this.signContractId = null;
        this.isProcess = false;
      }
    });
    // this.subscriptions.add(
    this.processingService.processingDataRun.subscribe(res => {
      this.selectedDraftAll = res;
      // this.dataIsProcess = res
    });
    //
    this.processingService.processingMultiSignStatus.subscribe(res => {
      this.isProcess = res;
    });
    this.processingService.processingInputReasonValue.subscribe(res => {
      this.inputReasonValue = res;
    });
    this.processingService.processingnewInitialInfoValue.subscribe(res => {
      this.newInitialInfoValue = res;
    });
    this.processingService.processingCheckMan.subscribe(res => {
      this.checkMan = res;
    });
    this.processingService.processingMultiSign.subscribe(res => {
      this.percent = res;
      // if (res === 100 ) {
      //   this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
      // }
    });
    if (!this.checkMan) {
      const numberCheckMan =  localStorage.getItem('checkMan');
      this.checkMan = parseInt(numberCheckMan,10);
      if (!this.checkMan) {
        this.documentMohaService.getSignContractFlowProcessingId().subscribe(rs => {
          if (rs && rs.data !== null) {
            const value = Object.values(rs.data)[0];
            if (value === 'SIGN_FLOW_LOT') {
              this.checkMan = 1 ;
            }
            if (value === 'DELETE_CONTRACT_LOT') {
              this.checkMan = 5 ;
            }
            if (value === 'CANCEL_FLOW_LOT') {
              this.checkMan = 2 ;
            }
            if (value === 'CONFIRM_SIGN_LOT') {
              this.checkMan = 3 ;
            }
          }
        });
      }
    }
    this.processingService.processingMultiSignCancel.subscribe(res => {
      this.isStop = res;
      if (res) {
        this.resetTable();
      }
    });
    this.documentTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this.onDestroySubject))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.documentTypes, this.documentTypesFilterCtrl, this.filteredDocumentTypes);
        });

    this.serviceTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this.onDestroySubject))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
        });

    this.getServiceTypeByEnterprise();

    this.isDocumentManager = true;
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.cecaEnable = localStorage.getItem('cecaEnable') == 'true';
    this.dataSource = new DocumentDataSource();
    this.loadData();
    // this.getParentBranches();
    this.notificationService.subscribeErrorService();
    // reset errorCode
    this.notificationService.resetErrorCode();
    // subscribe errorCode
    this.notificationService.getErrorCode().subscribe(errorCode => {
      if (errorCode === ErrorCode.NoAccessToContracts) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.toastr.error(this.message.getMessage('messages.contract_processed'));
        this.loadData();
      }
      if (errorCode === ErrorCode.ContractProcessed) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.loadData();
      }
    });

    window.scrollTo(0, 0);
    this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
    this.EventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
      (response) => {
        this.documentMohaService.isBuyContract1Mb.next(response.isBuyContract1Mb);
        this.documentMohaService.isBuyContract10Mb.next(response.isBuyContract10Mb);
        if (response.isBuyContract10Mb && !response.isBuyContract1Mb) {
          if (response.contractQuantity <= 0) {
            this.warningContractQuantity = true;
          }
        } else if (!response.isBuyContract10Mb && response.isBuyContract1Mb) {
          if (response.contract1MbQuantity <= 0) {
            this.warningContractQuantity = true;
          }
        } else if (response.isBuyContract10Mb && response.isBuyContract1Mb) {
          if (response.contract1MbQuantity <= 0 && response.contractQuantity <= 0) {
            this.warningContractQuantity = true;
          }
        } else {
          this.warningContractQuantity = true;
        }
      }
    );
  }

  onClickConfirmButton() {
    if (!this.isStop) {
      this.documentMohaService.signContractFlowProcessing(this.signContractId).subscribe((res) => {
        this.processingService.processingMultiSignStatus.next(true);
        this.timeOut = null;
        if (res && !res.success) {
          return;
        }
        if (res.data != '100') {
          this.percent = res.data;
          this.processingService.processingMultiSign.next(this.percent);
          this.timeOut = setTimeout(() => {
            this.onClickConfirmButton();
          }, 30000);
        } else {
          if(this.percent != '100' ) {
            this.toastr.success(this.message.getMessage('messages.sign_multi_finish'));
          }
          this.percent = res.data;
          this.processingService.processingMultiSign.next(100);
          this.resetTable();
        }
      });
    }

    //  this.actions.next(MultipleSignDialogComponent.CONFIRM_ACTION);
  }
  onClickConfirmButtonCancel() {
    if (!this.isStop) {
      this.documentMohaService.cancelContractFlow(this.signContractId).subscribe((res) => {
        this.processingService.processingMultiSignStatus.next(true);
        this.timeOut = null;
        if (res && !res.success) {
          return;
        }
        if (res.data != '100') {
          this.percent = res.data;
          this.processingService.processingMultiSign.next(this.percent);
          this.timeOut = setTimeout(() => {
            this.onClickConfirmButtonCancel();
          }, 1000);
        } else {
          this.processingService.processingInputReasonValue.next('');
          localStorage.removeItem("inputReasonValue");
          if(this.percent != '100' ) {
            this.toastr.success(this.message.getMessage('messages.cancel_multi_finish'));
          }
          this.percent = res.data;
          this.processingService.processingMultiSign.next(100);
          this.resetTable();
        }
      });
    }

    //  this.actions.next(MultipleSignDialogComponent.CONFIRM_ACTION);
  }
  onClickConfirmButtonSignProcess() {
    if (!this.isStop) {
      this.documentMohaService.confirmContractFlow(this.signContractId).subscribe((res) => {
        this.processingService.processingMultiSignStatus.next(true);
        this.timeOut = null;
        if (res && !res.success) {
          return;
        }
        if (res.data != '100') {
          this.percent = res.data;
          this.processingService.processingMultiSign.next(this.percent);
          this.timeOut = setTimeout(() => {
            this.onClickConfirmButtonSignProcess();
          }, 1000);
        } else {
          this.processingService.processingnewInitialInfoValue.next('');
          localStorage.removeItem("newInitialInfo");
          this.resetTable();
          if(this.percent != '100' ) {
            this.toastr.success(this.message.getMessage('messages.process_multi_finish'));
          }
          this.percent = res.data;
          this.processingService.processingMultiSign.next(100);
          this.resetTable();
        }
      });
    }

    //  this.actions.next(MultipleSignDialogComponent.CONFIRM_ACTION);
  }
  // tiến trình xóa
  onClickDeleteConfirmButton() {
    if (!this.isStop) {
      this.documentMohaService.deleteContractFlowProcessing(this.signContractId).subscribe((res) => {
        this.processingService.processingMultiSignStatus.next(true);
        this.timeOut = null;
        if (res && !res.success) {
          return;
        }
        if (res.data != '100') {
          this.percent = res.data;
          this.processingService.processingMultiSign.next(this.percent);
          this.timeOut = setTimeout(() => {
            this.onClickDeleteConfirmButton();
          }, 1000);
        } else {
          if(this.percent != '100' ) {
            this.toastr.success(this.message.getMessage('messages.delete_multi_finish'));
          }
          this.percent = res.data;
          this.processingService.processingMultiSign.next(100);
          this.resetTable();
        }
      });
    }
  }

  getColumnByUser(): Observable<boolean> {
    return this.documentMohaService.getColumnDynamic('CREATE_MY_CREATED_DOCUMENT').pipe(
      take(1),
      catchError(() => of(false)),
      tap(rs => {
        if (rs && rs.success) {
          if (rs.data) {
            const check = JSON.parse(rs.data);
            const recordsWithDefaultTrue = check.find(item => item.default === false);
            if (recordsWithDefaultTrue) {
              this.isCheckedAllColumn = false;
            } else {
              this.isCheckedAllColumn = true;
            }
            this.columnDefinitions = this.columnDefinitions.map(ele => {
              const checkDef = check.find(item => item.def === ele.def);
              return checkDef ? {...ele, default: checkDef.default} : ele;
            });
          }
        } else if (rs && !rs.success) {
          this.toastr.error(this.message.getMessage('messages.update_certificate_renew_server_error'));
        }
        // chi ap config va mo khoa list API; getDisplayedColumns() chay trong callback list
        // cung tick voi data -> header + data render cung 1 lan, khong trang thai trung gian
        this.columnConfigLoaded$.next(true);
      }),
      map(() => true)
    );
  }

  onCheckboxChange(column: any) {
    const recordsWithDefaultTrue = this.columnDefinitions.find(item => item.default === false);
    if (recordsWithDefaultTrue) {
      this.isCheckedAllColumn = false ;
    } else {
      this.isCheckedAllColumn = true ;
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    const codeColumnByUser = {
      code: "CREATE_MY_CREATED_DOCUMENT",
      value: JSON.stringify(this.columnDefinitions.map(item => ({
        def: item.def,
        default: item.default
      })))
    };
    this.documentMohaService.saveColumnDynamic(codeColumnByUser)
      .subscribe(res => {
      });
  }

  onAllColumnCheckboxChange(isCheck: any) {
    if (isCheck) {
      this.columnDefinitions.forEach((column) => {
        column.default = true;
      });
    } else {
      this.columnDefinitions.forEach((column) => {
        if (!column.check) {
          column.default = false;
        }
      });
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    const codeColumnByUser = {
      code: "CREATE_MY_CREATED_DOCUMENT",
      value: JSON.stringify(this.columnDefinitions.map(item => ({
        def: item.def,
        default: item.default
      })))
    };
    this.documentMohaService.saveColumnDynamic(codeColumnByUser)
      .subscribe(res => {
      });
  }

  changeWidthTable() {
    const check = this.columnDefinitions.filter(item => item.default === true);

    if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
      this.tableWidth = 1650;
    } else {
      let tableWidth;
      if (check.length === 9 || check.length === 10) {
        tableWidth = 950;
      } else if (check.length > 10) {
        tableWidth = 1650;
      }
      this.tableWidth = tableWidth;
    }
  }

  resetTable() {
    this.timeOut = setTimeout(() => {
      if (this.signContractId) {
        this.documentMohaService.signContractFlowInfo(this.signContractId).subscribe(res => {
          if (!res || !res.data.lotDetails) {
            return;
          }
          const data = res.data.lotDetails;
          this.signDoneQuantity = data.filter(item => {
            return item.status === 'DONE';
          }).length;
          this.signErrorQuantity = data.filter(item => {
            return item.status === 'ERROR';
          }).length;
          this.processingService.processingMultiSignStatus.next(false);
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          } else if (Math.ceil(this.paginate.totalRow / this.paginate.pageSize) === this.paginate.currentPage + 1
            && this.dataSource.data.value.length === this.signDoneQuantity) {
            this.paginate.currentPage = this.paginate.currentPage - 1;
          }

          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          this.signContractId = null;
          this.dataSelected.clear();
          this.processingService.processingMultiSignCancel.next(false);
          this.processingService.processingMultiSign.next(0);
          this.signContractId = null;
        });
      }
    }, 2000);
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
      this.tableWidth = 300;
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD && cd.default)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.filter(cd => cd.default).map(cd => cd.def );
      }
      this.changeWidthTable();
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => cd.def !== 'check')
    //     .map(cd => cd.def);
    // }
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    merge(this.sort.sortChange, page)
      .pipe(
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.EventWarningContractSubscription.unsubscribe();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.downloadService.clearData();
  }


  /**
   * Get parent branches for creating branch
   */
  // getParentBranches() {
  //   const enterpriseId = localStorage.getItem('enterpriseId');
  //   this.usService.getAllChild(
  //     enterpriseId
  //   ).subscribe(rs => {
  //     if (rs == null || rs.data == null) {
  //       return 0;
  //     }
  //     this.parentBranches = rs.data;
  //   });
  // }


  /**
   * Detect value changing in autocomplete input
   */
  onChangeAutoCompleted() {
    if (!this.selectedBranch) {
      this.oldData.enterprise = '';
      this.documentTypes = null;
      this.filteredDocumentTypes.next(this.documentTypes);
      this.serviceTypes = null;
      this.filteredServiceTypes.next(this.serviceTypes);
    } else if (this.selectedBranch) {
      this.oldData.enterprise = this.selectedBranch.id;
      this.documentTypeService.getByEnterprise(this.oldData.enterprise).subscribe(documentTypes => {
        this.documentTypes = documentTypes.data;
        this.filteredDocumentTypes.next(this.documentTypes.slice());
      });
      this.commonService.getTypeOfDocument(this.oldData.enterprise).subscribe(types => {
        this.serviceTypes = types.data;
        this.filteredServiceTypes.next(this.serviceTypes.slice());
      });
    }
  }

  getFilterCondition(page: number, pageSize: number, data: any): any {
    const {
      enterpriseContain,
      documentTypeContain,
      customerName,
      nameOrCodeContain,
      taxCode,
      statusContain,
      nameOrCode,
      createdTimeFrom,
      createdTimeTo,
      finishDateFromContain,
      finishDateToContain,
      parentContainID,
      serviceType,
      signRole,
      nameOrEmailOrPhoneUserSign,
      createdEnterpriseName,
      status,
      typeId,
      negotiate,
      formType,
      uuidContractMoha,
      mohaStatus,
      mohaConfirmStatus,
      isTerminated
    } = data;
    let filterCondition: any = {
      enterpriseId: enterpriseContain,
      docsTypeId: documentTypeContain, // mau tai lieu
      nameOrCode,
      signRole: signRole,
      serviceType,
      nameOrEmailOrPhoneUserSign: nameOrEmailOrPhoneUserSign,
      status,
      parentId: parentContainID,
      customer: customerName,
      page,
      pageSize,
      isTerminated: isTerminated

    };


    if (!this.isBasicSearchForm) {
      filterCondition = {
        ...filterCondition,
        createdTimeFrom,
        createdTimeTo,
        taxCode,
        finishDateFrom: finishDateFromContain,
        finishDateTo: finishDateToContain,
        serviceType,
        createdEnterpriseName,
        signRole: signRole,
        nameOrEmailOrPhoneUserSign: nameOrEmailOrPhoneUserSign,
        typeId,
        negotiate,
        formType,
        uuidContractMoha,
        mohaStatus,
        mohaConfirmStatus,
      };
    }

    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection;
    sortColumn = this.sortColumn; // is searching in parent

    let column = null;
    switch (sortColumn) {
      case 'name':
        column = {
          contractName: sortDirection
        };
        break;
      case 'createdTime':
        column = {
          createdTime: sortDirection
        };
        break;
    }

    filterCondition.sorts = column;

    return filterCondition;
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  /**
   * Get data when init
   */
  loadData(page: number = 0, pageSize: number = 10) {
    let paramDocumentType: '';
    let paramEnterprise: '';
    let paramNameOrCode: '';
    let paramCustomerName: '';
    let paramStatus: number;
    let paramServiceType: '';
    let paramTaxCode: '';
    let paramCreatedUser: '';
    let paramCreatedTimeFrom: any;
    let paramCreatedTimeTo: any;
    let paramFinishDateFrom: any;
    let paramFinishDateTo: any;
    let paramSignRoles: any;
    let paramNameOrEmailOrPhoneUserSign: '';
    let paramNegotiate: '';
    let paramFormType: '';
    let paramUuidContractMoha: '';
    let paramMohaStatus: number;
    let paramMohaConfirmStatus: number;

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        paramEnterprise = params.enterprise;
        paramDocumentType = params.documentType;
        paramNameOrCode = params.nameOrCode;
        paramCustomerName = params.customerName;
        paramStatus = params.status;
        paramNegotiate = params.negotiate;
        paramFormType = params.formType;
        // paramStatus = Common.DOCUMENT_STATUS.indexOf(params.status) == -1 ? 'null' : params.status;
        switch (params.status) {
          case 'totalDocumentsSigned':
            paramStatus = 2;
            break;
          case 'totalDocumentsWaitingForPartnersToSign':
            paramStatus = 8;
            break;
          case 'totalDocumentsWaitingForSigning':
            paramStatus = 1;
            break;
          case 'totalDocumentsDenied':
            paramStatus = 3;
            break;
          case 'totalDocumentsRejectedByPartners':
            paramStatus = 6;
            break;
          case 'totalDocumentsFinish':
            paramStatus = 7;
            break;
          default:
            paramStatus = params.status;

        }

        paramServiceType = params.serviceType || null;
        paramTaxCode = params.taxCode;
        paramCreatedUser = params.createdUser;
        paramCreatedTimeFrom = params.createdTimeFrom != null ? new Date(params.createdTimeFrom) : null;
        paramCreatedTimeTo = params.createdTimeTo != null ? new Date(params.createdTimeTo) : null;
        paramFinishDateFrom = params.finishDateFrom != null ? new Date(params.finishDateFrom) : null;
        paramFinishDateTo = params.finishDateTo != null ? new Date(params.finishDateTo) : null;
        page = params.page || 0;
        pageSize = params.pageSize && params.pageSize > 0 ? params.pageSize : 10;
        this.sortColumn = params.sortColumn != null ? params.sortColumn : null;
        this.sortDirection = params.sortDirection != null ? params.sortDirection : null;
      });

    this.documents.enterprise = paramEnterprise;
    this.documents.documentType = paramDocumentType;
    this.documents.nameOrCode = paramNameOrCode;
    this.documents.customerName = paramCustomerName;
    this.documents.status = paramStatus ? Number(paramStatus) : null;
    this.documents.serviceType = paramServiceType || null;
    this.documents.taxCode = paramTaxCode;
    this.documents.createdUser = paramCreatedUser;
    this.documents.createdTimeFrom = paramCreatedTimeFrom;
    this.documents.createdTimeTo = paramCreatedTimeTo;
    this.documents.finishDateFrom = paramFinishDateFrom;
    this.documents.finishDateTo = paramFinishDateTo;
    this.documents.signRole = paramSignRoles ? Number(paramSignRoles) : null;
    this.documents.nameOrEmailOrPhoneUserSign = paramNameOrEmailOrPhoneUserSign;
    this.documents.negotiate = paramNegotiate;
    this.documents.formType = paramFormType;

    if (paramEnterprise) {
      this.getBranch(paramEnterprise);
    }
    if ((paramServiceType && paramServiceType !== 'null') || paramTaxCode || paramCreatedUser
      || paramCreatedTimeFrom || paramCreatedTimeTo || paramFormType || paramNegotiate
      || paramFinishDateFrom || paramFinishDateTo) {
      this.isBasicSearchForm = false;
    } else {
      this.isBasicSearchForm = true;
    }

    // if (this.parentBranches) {
    //   this.selectedBranch = this.parentBranches.find(x => {
    //     return x.id === paramEnterprise;
    //   });
    // }

    // DESC or ASC
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }

    const filterData = {
      paramEnterprise,
      paramDocumentType,
      paramNameOrCode,
      paramCustomerName,
      paramStatus,
      paramServiceType,
      paramTaxCode,
      paramCreatedUser,
      paramCreatedTimeFrom,
      paramCreatedTimeTo,
      paramFinishDateFrom,
      paramFinishDateTo
    };

    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.setData([]);
    // Plan A: cho config cot tra ve roi moi goi list (lan dau; cac lan filter sau signal da bat)
    this.columnConfigLoaded$.pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this.documentMohaService
        .searchContractDocument(this.getFilterCondition(page, pageSize, this.documents)))
    )
      .subscribe(rs => {
        // doi header theo config BE; CD tick chay ngay sau callback se re-render header theo cot moi
        this.getDisplayedColumns();
        if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
          && rs.data.totalRow != null) {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
        }

        // data render trong macrotask sau CD tick -> rowDef.columns da cap nhat xong,
        // row luon dung theo cot config; an skeleton cung luc de header + data len cung thoi diem
        setTimeout(() => {
          this.isTableLoading = false;
          if (rs.data && rs.data.dataRow != null) {
            this.initParent(rs);
          }
        });
      }, () => this.isTableLoading = false);
  }

  /**
   * Get inform of branch
   */
  getBranch(branchId: number) {
    this.branchService.getBranch(branchId).subscribe(
      rs => {
        this.selectedBranch = {
          id: String(branchId),
          name: rs.data.name
        };
      }
    );
  }

  initChild(rs: any, parentID: string): void {
    let stt = this.childPaginateList[parentID].pageSize * this.childPaginateList[parentID].currentPage + 1;
    const childs = rs.data.dataRow as Document[];

    childs.forEach(child => {
      child.taxCode = (child.customerTaxCode == null || child.customerTaxCode === '') ?
        child.customerCertificateNo : child.customerTaxCode;
      child.STT = stt++;
      child.parentId = parentID;
    });
  }

  initParent(rs: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
    this.parentDocuments = rs.data.dataRow;
    this.parentDocuments.forEach(parent => {
      parent.taxCode = (parent.customerTaxCode == null || parent.customerTaxCode === '') ?
        parent.customerCertificateNo : parent.customerTaxCode;
      parent.STT = stt++;
      this.childPaginateList[parent.id] = new Paginate();
      this.childOldDataList[parent.id] = new Document();
      this.childSortList[parent.id] = new MatSort();
    });
    this.checkCheckAll();
    this.dataSource.setData(this.parentDocuments);
    this.childIsExexpanding = [];
  }

  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortColumn = sort.active;
  }

  sortChildData(sort: Sort, parentID: string) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortChildColumn[parentID] = sort.active;
    this.childSortList[parentID].direction = sort.direction;

    this.onFilterChildData(
      this.childPaginateList[parentID].currentPage,
      this.childPaginateList[parentID].pageSize, parentID);
  }

  onSearch(page: number = 0, pageSize: number = 10) {
    this.dataSource.data.value.forEach(data => {
      if (data.status === 1) {
        data.checked = false;
      }
    });
    this.checkAll = false;
    this.onFilterData(page, pageSize);
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {

    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }

    if (this.isBasicSearchForm) {
      this.documents.createdTimeFrom = null;
      this.documents.createdTimeTo = null;
      //this.documents.serviceType = null;
      this.documents.nameOrEmailOrPhoneUserSign = null;
      this.documents.signRole = null;
      this.isDisableNamePhoneEmail = true;
    }
    // set null for document model
    this.oldData.nameOrCode = this.oldData.nameOrCode || null;
    this.oldData.customerName = this.oldData.customerName || null;
    this.oldData.taxCode = this.oldData.taxCode || null;
    this.oldData.serviceType = this.oldData.serviceType || null;
    this.oldData.createdUser = this.oldData.createdUser || null;
    this.oldData.createdTimeFrom = this.oldData.createdTimeFrom || null;
    this.oldData.createdTimeTo = this.oldData.createdTimeTo || null;
    this.oldData.finishDateFrom = this.oldData.finishDateFrom || null;
    this.oldData.finishDateTo = this.oldData.finishDateTo || null;
    this.oldData.nameOrEmailOrPhoneUserSign = this.oldData.nameOrEmailOrPhoneUserSign || null;
    this.oldData.signRole = this.oldData.signRole || null;

    this.oldData.uuidContractMoha = this.oldData.uuidContractMoha || null;
    this.oldData.mohaStatus = this.oldData.mohaStatus || null;
    this.oldData.mohaConfirmStatus = this.oldData.mohaConfirmStatus || null;
    //this.oldData.isTerminated = (this.oldData.isTerminated !== undefined && this.oldData.isTerminated !== null) ? this.oldData.isTerminated : null;

    if (this.isBasicSearchForm) {
      this.documents.signRole = null;
      this.documents.nameOrEmailOrPhoneUserSign = '';
    }

    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.setData([]);
    // Plan A: cho config cot tra ve roi moi goi list (lan dau; cac lan filter sau signal da bat)
    this.columnConfigLoaded$.pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this.documentMohaService
        .searchContractDocument(this.getFilterCondition(page, pageSize, this.oldData)))
    )
      .subscribe(
        rs => {
          // doi header theo config BE; CD tick chay ngay sau callback se re-render header theo cot moi
          this.getDisplayedColumns();
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };

          // data render trong macrotask sau CD tick -> rowDef.columns da cap nhat xong,
          // row luon dung theo cot config; an skeleton cung luc de header + data len cung thoi diem
          setTimeout(() => {
            this.isTableLoading = false;
            this.initParent(rs);

            if (this.isBasicSearchForm) {
              this.documents.createdTimeFrom = null;
              this.documents.createdTimeTo = null;
              //this.documents.serviceType = null;
              this.documents.signRole = null;
              this.documents.nameOrEmailOrPhoneUserSign = '';
              this.isDisableNamePhoneEmail = true;
            }
          });
        }
        , () => this.isTableLoading = false
      );
  }

  onFilterChildData(page: number = 0, pageSize: number = 10, parentID: string) {

    if (this.childIsFirstLoadList[parentID] === false) {
      if (this.childSortList[parentID].direction === 'asc') {
        this.childSortDirection[parentID] = 'ASC';
      } else if (this.childSortList[parentID].direction === 'desc') {
        this.childSortDirection[parentID] = 'DESC';
      }

    } else {
      this.childIsFirstLoadList[parentID] = false;
    }

    this.documentMohaService.searchChildDocument(this.getFilterCondition(page, pageSize, {...this.oldData, parentID}))
      .subscribe(
        rs => {
          this.childPaginateList[parentID] = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };

          this.initChild(rs, parentID);
          this.childDataSourceList[parentID].setData(rs.data.dataRow);
        }
      );
  }

  closeExpandCollapse() {
    document.getElementById('noSpanTable').click();
  }

  expandedParent(parentID: string) {
    if (this.childIsExexpanding.includes(parentID)) {
      const index = this.childIsExexpanding.indexOf(parentID, 0);
      if (index > -1) {
        this.childIsExexpanding.splice(index, 1);
      }
      return;
    } else {
      this.childIsExexpanding.push(parentID);
    }
    this.childDataSourceList[parentID] = null;

    /* add child to parent to show  */
    this.parentDocuments.forEach(parentDocumentType => {
      if (parentDocumentType.id === parentID) {
        this.documentMohaService.searchChildDocument(this.getFilterCondition(0, 10, {...this.oldData, parentID}))
          .subscribe(rs => {
            if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
              && rs.data.totalRow != null) {
              this.childPaginateList[parentID] = {
                currentPage: rs.data.currentPage,
                pageSize: rs.data.pageSize,
                totalRow: rs.data.totalRow,
                totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
                totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
                no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
              };
            }
            if (rs.data && rs.data.dataRow != null) {

              this.childDataSourceList[parentID] = new DocumentDataSource();
              this.childDataSourceList[parentID].setData(rs.data.dataRow);
              this.initChild(rs, parentID);
            }
          });
      }
    });
  }

  /**
   * Delete document
   * xóa
   */
  delete(id: any, parentId: string = null, documentName: string) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_docs'), documentName)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.documentMohaService.delete(id).subscribe(() => {
          this.toastr.success(this.message.getMessage('messages.delete_success'));
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          }
          // is parent element
          if (parentId == null || parentId === '') {
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          } else {
            this.onFilterChildData(
              this.childPaginateList[parentId].currentPage,
              this.childPaginateList[parentId].pageSize, parentId);
          }
          this.dataSelected.delete(id);
        });
      }
    });
  }

  openMutipleSignDocument(isAllDraft?: boolean) {
    const selectedValues = Array.from(this.dataSelected.values()) || [];
    this.isDraftAll = isAllDraft ? 2 : 1;
    if (this.isProcess) {
      this.subTitleDraftAll = '';
      const popup = this.dialog.open(ListMultipleSignDialogComponent, {
        width: '80%',
        data: this
      });
    } else {
      if (!isAllDraft) {
        if (selectedValues.some(e => e.status === 1)) {
          this.selectedDraftAll = [];
          this.selectedDraftAll = selectedValues.filter(e => e.status === 1);
          const subTitleStr = this.commonService.format(this.message.getMessage('messages.confirm_force_sign_list_docs'), selectedValues.length - this.selectedDraftAll.length, selectedValues.length, this.selectedDraftAll.length);
          const subTitleStrTotalDraft = this.commonService.format(this.message.getMessage('messages.confirm_sign_list_docs_draft'), this.selectedDraftAll.length);
          this.subTitleDraftAll = this.selectedDraftAll.length === selectedValues.length ? '' : subTitleStr;
          this.subTitleDraftAllTotal = subTitleStrTotalDraft;
          const popup = this.dialog.open(ListMultipleSignDialogComponent, {
            width: '80%',
            data: this
          });
        } else {
          const dialogRef = this.dialog.open(NotifyWarningCustomComponent, {
            width: '600px',
            data: {
              highligth: true,
              content: this.commonService.format(this.message.getMessage('messages.reject_sign_list_docs')),
            }
          });
        }
      } else {
        this.documentMohaService.getSignAllDraft().subscribe(rs => {
          if (rs.success) {
            this.selectedDraftAll = [];
            this.selectedDraftAll = rs.data.dataRow;
            if (this.selectedDraftAll.length === 0) {
              const dialogRef = this.dialog.open(NotifyWarningCustomComponent, {
                width: '600px',
                data: {
                  highligth: true,
                  content: this.commonService.format(this.message.getMessage('messages.reject_list_docs_1000')),
                }
              });
            } else {
              this.subTitleDraftAll = this.commonService.format(this.message.getMessage('messages.confirm_sign_list_docs_draft'), this.selectedDraftAll.length);
              const popup = this.dialog.open(ListMultipleSignDialogComponent, {
                width: '80%',
                data: this
              });
            }
          } else {
            this.toastr.error(rs.mesage);
          }
        });
      }
    }
  }

  /**
   Delete
   Xóa nhiều bản ghi
   */
  deleteAll(isAllDraft?: boolean) {
    this.isDraftAll = isAllDraft ? 4 : 3;
    if (this.isProcess) {
      this.subTitleDraftAll = '';
      const popup = this.dialog.open(ListMultiDeleteDialogComponent, {
        width: '80%',
        data: this
      });
    } else {
      if (!isAllDraft) {
        this.selectedDraftAll = [];
        const selectedValues = Array.from(this.dataSelected.values()) || [];
        this.selectedDraftAll = selectedValues.filter(v => v.status === 1);
        if (!selectedValues.some(e => e.status === 1)) {
          const dialogRef = this.dialog.open(NotifyWarningCustomComponent, {
            width: '600px',
            data: {
              highligth: true,
              content: this.commonService.format(this.message.getMessage('messages.reject_delete_list_docs')),
            }
          });
        }
        if (this.selectedDraftAll.length > 0) {
          if (selectedValues.length === this.selectedDraftAll.length) {
            this.subTitleDraftAll = '';
            this.subTitleDraftAllTotal = this.commonService.format(this.message.getMessage('messages.confirm_delete_all_contract_draft'), this.selectedDraftAll.length);
          } else {
            const subTitleStr = this.commonService.format(this.message.getMessage('messages.confirm_force_delete_list_docs'), selectedValues.length - this.selectedDraftAll.length, selectedValues.length, this.selectedDraftAll.length);
            const subTitleStrTotal = this.commonService.format(this.message.getMessage('messages.confirm_delete_all_contract_draft'), this.selectedDraftAll.length);
            this.subTitleDraftAll = subTitleStr;
            this.subTitleDraftAllTotal = subTitleStrTotal;
          }
          const dialogRef = this.dialog.open(ListMultiDeleteDialogComponent, {
            width: '80%',
            data: this
          });
        }
      } else {
        this.documentMohaService.getDeleteAllDraft().subscribe(rs => {
          if (rs.success) {
            this.selectedDraftAll = [];
            this.selectedDraftAll = rs.data.dataRow;
            if (this.selectedDraftAll.length === 0) {
              const dialogRef = this.dialog.open(NotifyWarningCustomComponent, {
                width: '600px',
                data: {
                  highligth: true,
                  content: this.commonService.format(this.message.getMessage('messages.reject_delete_list_docs_1000')),
                }
              });
            } else {
              this.subTitleDraftAll =  this.commonService.format(this.message.getMessage('messages.confirm_delete_all_contract_draft'), this.selectedDraftAll.length );
              const popup = this.dialog.open(ListMultiDeleteDialogComponent, {
                width: '80%',
                data: this
              });
            }
          } else {
            this.toastr.error(rs.mesage);
          }
        });
      }
    }
  }

  /**
   * Start Flow
   * Thực hiện luồng ký
   */

  startSignFlow(element) {
    if (this.userType == 1 || this.userType == 2) {
      this.documentMohaService.getCheckVneidConfirm(element.id, true, true).subscribe(res => {
        if (res.success) {
          this.dataCheckVneid = res.data;
          switch (this.dataCheckVneid.typeVerify) {
            case 'SHARE_INFO':
              this.openRequestConfirmIdentity(element);
              break;
            case 'FACE_MATCH':
            this.openRequestConfirmIdentity(element);
              break;
            case 'VERIFIED':
              this.continueStartSignFlow(element);
              break;
          }
        } else {
          this.toastr.error(res.message);
        }
      })
    } else {
      this.continueStartSignFlow(element);
    }
  }

  private openRequestConfirmIdentity(element, verificationData?: any): void {
    const dialogRef = this.dialog.open(RequestConfirmIdentityComponent, {
      width: this.deviceService.isMobile() ? '100%' : '640px',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.openEnterIdentityVneid(element);
      }
    });
  }

  private openEnterIdentityVneid(element, verificationData?: any): void {
    const dialogRef = this.dialog.open(EnterIdentityVneidComponent, {
      panelClass: 'sign-authentication',
      width: '1080px',
      maxWidth: '90vw',
      height: 'auto',
      disableClose: true,
      data: {
        documentId: element.id,
        dataCheckVneid: this.dataCheckVneid,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        this.openRequestConfirmIdentity(element);
        return;
      } else {
        this.continueStartSignFlow(element);
      }
    });
  }

  private continueStartSignFlow(element): void {
    this.checkTindy(() => this.confirmStartSignFlow(element));
  }

  private confirmStartSignFlow(element): void {
    const documentId = element.id;
    const documentName = element.name;
    const documentStatus = element.status;
    const autoSign = element.autoSign;
    let message = 'messages.confirm_start_flow';
    if (autoSign) {
      message = 'messages.confirm_start_flow_auto_sign';
    }
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(this.message.getMessage(message), documentName)
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.documentMohaService.sendStartSignFlow(documentId).subscribe(res => {
          if(res.success) {
            this.toastr.success(this.message.getMessage('messages.start_flow_success'));
            // bind datasource again
            this.dataSelected.delete(documentId);
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          } else {
            this.toastr.error(res.message);
          }
        });
      }
    });
  }

  notifySignContract(element) {
    this.documentMohaService.getAllUserProcessById(element.id).subscribe(res => {
      if (res.success && res.data.length > 0) {
        const dialogRe = this.dialog.open(ListSignContractNotifyComponent, {
          width: '700px',
          data: {data: element, listUser: res.data},
        });
        dialogRe.afterClosed().subscribe(rs => {
          if (rs) {
            this.toastr.success(this.message.getMessage('messages.notify_sign_contract_user_success'));
          }
        });
      } else {
        this.toastr.error(this.message.getMessage('messages.action_notify_sign_contract_error'));
        this.router.navigate(['/home-enterprise/search-my-created-document']);
      }
    }, err => {
      this.toastr.error(this.message.getMessage('messages.action_notify_sign_contract_error'));
    });

  }

  /**
   * Chuyển tiếp HĐ
   * Forward Contract
   */

  forwardContract(element) {
    const dialogRe = this.dialog.open(ForwardContractDialogComponent, {
      width: '800px',
      data: {data: element},
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.toastr.success(this.message.getMessage('messages.notify_sign_contract_user_success'));
      }
    });
  }

  /**
   * Cancel Flow
   * Hủy luồng ký
   */

  cancelSignFlow(id: string, document: any) {
    const dialogWarningRef = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_cancel_flow1'), document.name),
    });
    dialogWarningRef.afterClosed().subscribe(rs => {
      if (rs && id) {
        this.dialogRef = this.dialog.open(CancelSignFlowComponent, {
          width: '500px',
          data: {
            id,
            document
          }
        });

        this.dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            // bind datasource again
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          }
        });
      }
      dialogWarningRef.close();
    });
  }

  /**
   * Signature Proces
   * Trình ký xác nhận
   */

  openDialogSignatureProcess(id: string, document: any) {
    this.dialogRef = this.dialog.open(SignatureProcessDialogComponent, {
      width: '550px',
      data: {
        id: id,
        name: null,
        isAutoSign: false,
        contractId: id
      }
      // userSign: this.userSign,
    });
    this.dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
      }
    });
  }

  /**
   * Re Signature Proces
   * Trình ký xác nhận lại
   */

  openDialogReSignatureProcess(id: string, document: any) {
    this.documentMohaService.getContractUserApprove(id).subscribe(rs => {
      if (!rs || !rs.data || rs.data.length === 0) {
        this.toastr.error(this.message.getMessage('cancel_sign_confirm.resignature_error'));
        this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        return;
      }
      this.dialogRef = this.dialog.open(ReSignatureProcessDialogComponent, {
        width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '750px',
        maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
        data: {
          id: id,
          name: null,
          isAutoSign: false,
          contractId: id,
          document: document,
          contractUserApprove: rs.data,
        }
        // userSign: this.userSign,
      });
      this.dialogRef.afterClosed().subscribe(rs => {
        if (rs) {
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        }
      });
    });
  }

  /**
   * Cancel Signature Process
   * Hủy trình ký xác nhận
   */

  openDialogCancelSignatureProcess(id: string, document: any) {
    this.documentMohaService.getContractUserApprove(id).subscribe(rs => {
      if (!rs || !rs.data || rs.data.length === 0) {
        this.toastr.error(this.message.getMessage('cancel_sign_confirm.canceled_signature'));
        this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        return;
      }
      this.dialogRef = this.dialog.open(WarningCancelSignConfirmationComponent, {
        width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '750px',
        maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
        data: {
          contractId: id,
          contractUserApprove: rs.data,
          document: document
        }
      });
      this.dialogRef.afterClosed().subscribe(rs => {
        if (rs) {
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        }
      });
    });
  }

  /**
   * Send link Contract
   * Gửi link HĐ
   */

  sendLinkContract(id: string, document) {
    this.documentMohaService.getCustomerProcessing(id).subscribe(async rs => {
      if (rs.success && rs.data.length > 0) {
        // console.log('rs success =true', rs)
        this.dialogRef = this.dialog.open(ResendContractDialogComponent, {
          width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
          maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
          data: {
            contractId: id,
            document: document,
            dataSource: rs.data,
            width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
            maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw'
          }
        });
        this.dialogRef.afterClosed().subscribe(rs => {
          if (rs) {
            this.toastr.success(this.message.getMessage('messages.send_link_contract_user_success'));
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          }
        });
      } else {
        this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        if (rs.success && rs.data && rs.data.length == 0) {
          this.toastr.error(this.message.getMessage('messages.none_customer'));
        } else {
          this.toastr.error(rs.message);
        }
      }
    }, err => {
      this.toastr.error(this.message.getMessage('messages.send_link_contract_user_error'));
      this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
    });
  }

  /**
   * Open dialog Update
   * @param element model document
   */
  onUpdate(element) {
    this.getDocumentById(element.id);
  }

  /**
   * Get document type by id to check status of document type
   */
  checkStatusDocumentType(documentId: string, documentTypeEnterpriseId: string, callback: () => void, error: string) {
    this.documentTypeService.findById(documentTypeEnterpriseId).subscribe(rs => {
      if (rs.data && rs.data.status && rs.data.relationStatus) {
        callback();
      } else {
        const dialog = this.dialog.open(WarningComponent, {
          width: '40%',
          data: this.message.getMessage('messages.use_inactive_template')
        });
        dialog.afterClosed().subscribe(ref => {
          if (ref) {
            this.toNavigate('/home-enterprise/update-document-moha/' + documentId, {goFrom: 'hdld', typeUpdate: true});
          }
        });
      }
    });
  }

  /**
   * Get document by id.
   * @param id the document id.
   */
  getDocumentById(id: string) {
    if (id) {

      this.documentMohaService.getDocumentById(id).subscribe(rs => {
        if (!rs || !rs.data) {
          return;
        }
        if (rs.data.contractDTO && rs.data.contractDTO.typeId === 0) {
          this.checkStatusDocumentType(id, rs.data.contractDTO.documentTypeEnterpriseId, () => {
            this.toNavigate('/home-enterprise/update-document-moha/' + id, {goFrom: 'hdld', typeUpdate: true});
          }, 'messages.document_stop');
        } else {
          this.toNavigate('/home-enterprise/update-document-moha/' + id, {goFrom: 'hdld', typeUpdate: true});
        }
      });
    }
  }

  /**
   * Navigate to view detail document
   */
  viewDetail(element, type?) {
    if (type) {
      this.toNavigate('/home-enterprise/view-document-moha/' + element.id, {goFrom: 'hdld', typeCopy: type });
    } else {
        this.toNavigate('/home-enterprise/view-document-moha/' + element.id, {goFrom: 'hdld'} );
    }
  }

  /**
   * Open PDF By Browser
   */
  openPDFByBrowser(documentData: any) {
    if (documentData.id) {
      this.documentMohaService.downloadFileZip(documentData.id).subscribe(res => {
        const blobUrl = URL.createObjectURL(res);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = documentData.name + '.zip';
        a.click();
      });
    }
  }

  multiDownload() {
    this.downloadService.setData({
      contractIds: Array.from(this.dataSelected.keys()),
      menuContract: EnumDownloadMenuName.SEARCH_DOCUMENT_MINE,
    });
  }

  signatureProcess() {
    if (this.isProcess) {
      const dialogRe = this.dialog.open(ListSignatureProcessPopupComponent, {
        width: '80%',
        data: this,
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.toastr.success(this.message.getMessage('messages.notify_sign_contract_user_success'));
        }
      });
    } else {
      const data = [];
      this.dataSelected.forEach((ele, index) => {
        data.push(ele.id);
      })
      this.documentMohaService.validateSignaturePprocess(data).subscribe(res => {
        if (res) {
          this.SignatureProcess = res.data.contractSuccess;
          if (this.SignatureProcess.length > 0) {
            // dataPopup.push({data:res.data.contractSuccess},{total:res.data.total})
            const dialogRe = this.dialog.open(ListSignatureProcessPopupComponent, {
              width: '80%',
              data: this,
            });
            dialogRe.afterClosed().subscribe(rs => {
              if (rs) {
                this.toastr.success(this.message.getMessage('messages.notify_sign_contract_user_success'));
              }
            });
          } else {
            const dialogRef = this.dialog.open(NotifyWarningCustomComponent, {
              width: '600px',
              data: {
                content: this.commonService.format(this.message.getMessage('messages.reject_signature_process_list_docs')),
              }
            });
          }
        }
      })
    }

  }

  cancelFlow() {
    const  data = [];
    this.dataSelected.forEach(ele =>{
      if(ele.status == 2 || ele.status == 9){
        data.push(ele);
      }
    })
    if(data.length > 0 || this.isProcess) {
      const dialogRe = this.dialog.open(ListPopupCancelFlowComponent, {
        width: '80%',
        data: this,
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.toastr.success(this.message.getMessage('messages.notify_sign_contract_user_success'));
        }
      });
    }
    else {
      const dialogRef = this.dialog.open(NotifyWarningCustomComponent, {
        width: '600px',
        data: {
          content:this.isNotAttestedUser ? this.commonService.format(this.message.getMessage('messages.reject_cancel_flow_list_docs')) : this.commonService.format(this.message.getMessage('messages.reject_cancel_flow_list_docs_1')),
        }
      });
    }
  }

  /**
   * Copy document
   */
  copyDocument(id: string, type?: any) {
    if (id) {
      if (this.documents.documentType === 1) {
        this.toastr.error(this.message.getMessage('messages.document_no_copy'));
      } else {
        this.documentMohaService.checkTemplate(id).subscribe(rs => {
          if (rs && rs.code === ErrorCode.DocumentInactive) {
            this.toastr.error(this.message.getMessage('messages.copy_contract_error_template_inactive'));
            return;
          }

          if (rs && rs.code === ErrorCode.CopyNotPermission) {
            this.toastr.error(rs.message);
            return;
          }

          this.documentMohaService.checkContractTerminationCopy(id).subscribe(res =>{
            if (res.success) {
              this.toNavigate('/home-enterprise/update-document-moha/' + id, {
                flagCopy: true,
                goFrom: 'hdld',
                typeCopy: type
              });
            } else {
              this.toastr.error(res.message)
            }
          })
        });
      }
    }
  }

  onClickBtnFilter() {
    this.oldData = this.documents;
    this.addColumnTable();
    // if (!((this.documents.signRole == null || this.documents.signRole == 'null' ) || this.documents.nameOrEmailOrPhoneUserSign == null) ) {
    //   if (this.columnDefinitions.length < 9) {
    //     const action =  this.columnDefinitions.pop();
    //     this.columnDefinitions.push(
    //       { def: "userSign", showXS: false, showSM: false, showMD: false }
    //     )
    //     this.columnDefinitions.push(
    //       { def: "role", showXS: false, showSM: false, showMD: false }
    //     )
    //     this.columnDefinitions.push(action);
    //     this.getDisplayedColumns();
    //   }
    //
    // } else {
    //   if (this.columnDefinitions.length > 9) {
    //     const action =  this.columnDefinitions.pop();
    //     this.columnDefinitions.pop()
    // this.columnDefinitions.pop()
    //     this.columnDefinitions.push(action);
    //     this.getDisplayedColumns();
    //   }
    // }
  }

  addColumnTable() {
    if (this.isBasicSearchForm) {
      if (this.columnDefinitions.length > 18) {
        const action = this.columnDefinitions.pop();
        if (!this.isVContract) {
          this.columnDefinitions.pop();
        }

        this.columnDefinitions.push(action);
        this.getDisplayedColumns();
      }
    } else {
      if (!((this.documents.signRole == null || this.documents.signRole == 'null') || this.documents.nameOrEmailOrPhoneUserSign == null) && !this.isBasicSearchForm) {
        if (this.columnDefinitions.length < 19) {
          const action = this.columnDefinitions.pop();
          this.columnDefinitions.push(
            {def: 'userSign', default: true , showXS: true, showSM: true, showMD: true,  name: 'enterprise_contract.table_headers.user_sign', check: true}
          );
          this.columnDefinitions.push(
            {def: 'role', default: true ,  showXS: true, showSM: true, showMD: true,  name: 'enterprise_contract.table_headers.role', check: true}
          );
          this.columnDefinitions.push(action);
          this.getDisplayedColumns();
        }
      } else {
        if (this.columnDefinitions.length > 19) {
          const action = this.columnDefinitions.pop();
          this.columnDefinitions.pop();

          if (!this.isVContract) {
            this.columnDefinitions.pop();
          }

          this.columnDefinitions.push(action);
          this.getDisplayedColumns();
        }
      }
    }
    this.onFilterData(0, this.paginate.pageSize);
  }

  signRoleChanged(data: any) {

    if (this.documents.signRole === null || this.documents.signRole === 'null') {
      this.documents.nameOrEmailOrPhoneUserSign = null;
      this.documents.signRole = null;
      this.isDisableNamePhoneEmail = true;
    } else {
      this.isDisableNamePhoneEmail = false;
    }
    this.ngForm.control.markAllAsTouched();
  }

  /**
   * Open screen add document
   */
  // onAddDocument() {
  //   this.toNavigate('/home-enterprise/add-document/');
  // }

  /**
   * Open advanced search form
   */
  onExpandAdvancedSearchForm() {
    this.isBasicSearchForm = false;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Close advanced search form
   */
  onCloseAdvancedSearchForm() {
    this.isBasicSearchForm = true;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Set params for to navigate
   */
  toNavigate(route, params = {}) {
    let queryParams: any = {
      ...params,
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize,
      routeLink: '/home-enterprise/search-my-created-document/',
      documentType: this.documents.documentType,
      enterprise: this.documents.enterprise,
      nameOrCode: this.documents.nameOrCode,
      customerName: this.documents.customerName,
      status: this.documents.status,
      signRole: this.documents.signRole,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    };

    if (!this.isBasicSearchForm) {
      queryParams = {
        ...queryParams,
        serviceType: this.documents.serviceType,
        taxCode: this.documents.taxCode,
        createdUser: this.documents.createdUser,
        createdTimeFrom: this.documents.createdTimeFrom,
        createdTimeTo: this.documents.createdTimeTo,
        finishDateFrom: this.documents.finishDateFrom,
        finishDateTo: this.documents.finishDateTo,
        negotiate: this.documents.negotiate,
        formType: this.documents.formType,
      };
    }

    this.router.navigate([route], {queryParams});
  }

  /**
   * Open screen add contract lot
   */
  onAddLot() {
    this.router.navigateByUrl('/home-enterprise/contract-lot-moha');
  }

  checkAllCheckBox() {
    this.dataSource.data.value.forEach(data => {
      data.checked = this.checkAll;
      if (data.checked) {
        this.dataSelected.set(data.id, data);
      } else {
        // this.checkAll = false;
        this.dataSelected.delete(data.id);
      }
    });
    this.dataSelected.forEach(ele =>{
      if(ele.status == 9){
        this.checkSignatureProcess = 1;
      }
      if(ele.status == 2){
        this.checkCancelFlow = 1;
      }
    })
  }

  public onSelect(element) {
    if (this.dataSource == null
      || this.dataSource.data == null
      || this.dataSource.data.value == null
      || this.dataSource.data.value.length === 0) {
      return;
    }
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }
    this.checkCheckAll();
  }

  getCECAStatus(element) {
    let statusString = 'Hoàn thành';
    switch (element.bctConfirmStatus) {
      case this.enumContractStatus.DRAFT:
      case this.enumContractStatus.PROCESSING:
        statusString = 'Đang xử lý xác thực lên trục BCT';
        break;
      case this.enumContractStatus.REJECTED:
        statusString = 'Xác thực lên trục BCT thất bại';
        break;
      case this.enumContractStatus.FINISHED:
        statusString = 'Xác thực lên trục BCT thành công';
        break;
      default:
        statusString = 'Trạng thái không xác định';
    }
    return statusString;
  }

  getConfirmBCTStastus(element) {
    let statusString = '';
    if (element.status !== this.enumContractStatus.FINISHED) {
      return '';
    }

    switch (element.bctConfirmStatus) {
      case this.enumContractStatus.DRAFT:
      case this.enumContractStatus.PROCESSING:
        statusString = 'headertable.bct_process';
        break;
      case this.enumContractStatus.REJECTED:
        statusString = 'headertable.bct_error';
        break;
      case this.enumContractStatus.FINISHED:
        statusString = 'headertable.bct_finish';
        break;
      default:
        statusString = '';
    }

    return statusString;
  }

  checkCheckAll() {
    if (this.dataSelected.size === 0) {
      this.checkAll = false;
      return;
    }
    // set data checked when id in select
    this.parentDocuments.forEach(doc => doc.checked = this.dataSelected.has(doc.id));
    this.checkAll = this.parentDocuments.every(doc => this.dataSelected.has(doc.id));
    this.checkSignatureProcess = 2;
    this.checkCancelFlow = 2;
    this.dataSelected.forEach(ele =>{
      if(ele.status == 9){
        this.checkSignatureProcess = 1;
      }
      if(ele.status == 2){
        this.checkCancelFlow = 1;
      }
    })
  }

  retry(id) {
    this.blockUI.reset();
    this.blockUI.start('');
    this.documentMohaService.retrySignFlow({contractId: id}).subscribe(
      res => {
        if (res && res.success) {
          this.toastr.success(this.message.getMessage('digital_certificate_management.retry_success'));
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          }
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        } else {
          if (res.code === ErrorCode.NotEnoughMoneyTimestamp) {
            this.dialog.open(NotifyWarningComponent, {
              data: this.message.getMessage('digital_certificate_management.retry_error')
            });
          } else if (res.code === ErrorCode.RetryExpiredMOIT) {
            this.toastr.error(res.message);
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          } else {
            this.toastr.error(res.message);
          }
          this.blockUI.stop();
        }
      }
    );
  }

  /** Return customer group by format <customer group name 1>, <customer group name 2>. */
  transformListCustomerGroupToString(customerGroups: CustomerGroup[]){
    return ((customerGroups && customerGroups.length > 0) ? customerGroups : []).map(value => value.name).join(", ");
  }

  getColorTagExpireStatus(expireStatus) {
    let color = ''
    switch (expireStatus) {
      case '1':
        color = 'blue'
        break
      case '2':
        color = 'orange'
        break
      case '3':
        color = 'red'
        break
    }
    return color
  }

  checkPermissionCreateContract() {
    if(this.commonService.checkDefaultAdmin()) {
      return true;
    }
    if(this.permissions.includes(12)) {
      return true;
    }
    return false;
  }

  getMethodCreation(typeId: any){
    if(typeId == 1){
      return this.message.getMessage('search_form.upload')
    } else if (typeId == 0) {
      return this.message.getMessage('search_form.template')
    } else {
      return ''
    }
  }

  shareContract(element){
    const dialog1 = this.dialog.open(ListManageContractSharePartnerComponent, {
      width: '60vw',
      data: element
    })
    dialog1.afterClosed().subscribe(res =>{
      if(res){

      }
    })
  }

  terminationContract(element){
    this.blockUI.start()
    this.documentMohaService.checkContractTermination(element.id).subscribe(rs => {
      this.blockUI.stop()
      if(rs.success){
        const dialogRef = this.dialog.open(ListConfirmTerminationComponent, {
          data: this.message.getMessage('contract_terminate.use_old_signflow')
        })
        dialogRef.afterClosed().subscribe(res =>{
          if(res){
            this.toNavigate('/home-enterprise/update-document-moha/' + element.id, {
              termination: true,
              goFrom: 'hdld',
              terminationType: res === 'NEW' ? 1 : 2
            });
          }
        })
      } else {
        this.toastr.error(rs.message)
      }
    })
  }

  getFormType(formType: string){
    if(formType == 'CONTRACT'){
      return this.message.getMessage('add_document_moha.employment_contract')
    } else if (formType == 'CONTRACT_APPENDIX') {
      return this.message.getMessage('add_document_moha.employment_contract_addendum')
    } else {
      return ''
    }
  }

  changeContractStatus(){
    if(this.documents.status == this.enumContractStatus.TERMINATED || this.documents.status == this.enumContractStatus.TERMINATING){
      this.documents.formType = 'CONTRACT'
      this.cdr.detectChanges()
    } 
      if(this.documents.status == this.enumContractStatus.TERMINATED_CONTRACT){
        // this.documents.isTerminated = true;
        // this.documents.status = null;
      }

      if(this.documents.status == this.enumContractStatus.TERMINATING_CONTRACT){
        // this.documents.isTerminated = false;
        // this.documents.status = null;
      }      
      this.cdr.detectChanges()
    this.onClickBtnFilter()
  }

  trimInput(fieldName: string) {
    if (this.documents[fieldName]) {
      this.documents[fieldName] = this.documents[fieldName].trim();
    }
  }

  checkTindy(callback?: () => void){
    this.contractService.checkTindyUser().subscribe(ref => {
      if(!ref.success){
        this.toastr.error(ref.message);
        return;
      }
      if(ref.data == 0 || ref.data == 2 ){
         //Popup anthention data
          let message = "";
         if(ref.data == 2){
         message = this.message.getMessage('notifyTindy.notify');
         }else if(ref.data == 0){
         message = this.message.getMessage('notifyTindy.notify_2')
         }
        const confirmDialog = this.dialog.open(WarningDataAuthenticationComponent, {
        width: '469px',
        height: '348px',
        data: {
          message
        }
         });
         confirmDialog.afterClosed().subscribe(ref => {
          if (ref) {
            this.dialog.open(SignAuthenticationPopupComponent, {
            panelClass: 'sign-authentication',
            width: '791px',
            height: 'auto',
            data: {
              message
            }
          });
          }
       });
      }else if(ref.data == 1){
        if(callback) callback();
      }
    })
  }

  reAuthenticate(id: string) {
    this.documentMohaService.reTryAuthenMessage(id).subscribe(res => {
      if (!res.success) {
        this.toastr.error(this.message.getMessage('messages.re_authentication_fail'));
      } else {
        this.toastr.success(this.message.getMessage('messages.re_authentication_success'));
        this.loadData();
      }
    })
  }

}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: any;
  no: any;
}

export class Document {
  STT: number;
  name: string; //
  id: string; //
  code: string; //
  createdTime: any;
  createdTimeFrom: string;
  createdTimeTo: string;
  finishDate: string;
  finishDateFrom: string;
  finishDateTo: string;
  createdUser: string;
  customerName: string;
  taxCode: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  customerGroups: CustomerGroup[]; // Nhóm khách hàng
  status: any;
  parentId: string;
  enterprise: string;
  documentType: any;
  serviceType: any;
  email: string;
  hasChildren: boolean;
  nameOrCode: string;
  typeId: any;
  isDifferentEnterprise: boolean;
  signRole: any;
  nameOrEmailOrPhoneUserSign: string;
  checked: boolean;
  submittedByATime: Date;
  expireStatus: string;
  negotiate: any;
  formType: any;
  userSign: any;
  role: any;
  isTerminated: any;
  // 1 không được phân quyền ký
  // 2 được phân quyền ký
  // 3 chỉ xem và copy
  // is parent element
  permission: number;

  // DRAFT(0),
  // WAIT_1(1),
  // SINGED_1(2),
  // REJECT_1(3),
  // WAIT_2(4),
  // SINGED_2(5),
  // REJECT_2(6);
  // Finish (7); ?
  // 0 - Nháp
  // 1- Chờ ký bên lập
  // 2 - Đã ký bên lập
  // 3 - Từ chối bên lập
  // 4 - Chờ ký bên nhận
  // 5 - Ký bên nhận
  // 6 - Từ chối bên nhận
  // 7 - HOÀN THÀNH
  // 8 - Mới gởi qua bên nhận
  uuidContractMoha: string;
  mohaStatus: number;
  mohaConfirmStatus: number;

  // hồi sửa lại sau
  getPermission(): void {
    if (this.status === 3 || this.status === 6 // reject
      || this.status === 1 // được ký bởi bên lập
      || this.status === 7) { // Finish
      this.permission = 3;
    } else if (this.status === 1 || this.status === 4) {
      this.permission = 2;
    } else {
      this.permission = 1;
    }
  }
}

export class SortKeyPair {
  /* @ViewChild(MatSort, { static: false }) sort: MatSort; */
  [key: string]: MatSort;
}

export class BooleanKeyPair {
  [key: string]: boolean;
}

export class StringKeyPair {
  [key: string]: string;
}

export class DocumentKeyPair {
  [key: string]: Document;
}

export class DocumentTypeDataSourceKeyPair {
  [key: string]: DocumentDataSource;
}

export class PaginateKeyPair {
  [key: string]: Paginate;
}

export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  constructor() {
    super();
  }

  setData(data: Document[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}

/** Create CustomerGroup Type. */
export class CustomerGroup{
  id?: string;
  name?: string;
}
